<template>
<v-container>
  <v-layout row wrap align-center justify-center class="ma-4">
    <img width="160" height="160" :src="require('../../assets/LogoIcons/logo_color.svg')" class="px-2"></img>
    <div>
      <h1 class="px-2 py-2 display-2 text-xs-center text-sm-center text-md-left"><b>{{ $appName }}</b></h1>
      <v-btn round outline class="secondary--text">{{ $t('introduce.slogan') }}</v-btn>
    </div>
  </v-layout>

  <v-layout row wrap>
    <v-flex xs12 sm6 md3 class="py-4">
      <v-card class="mx-4 elevation-8 text-xs-center" style="height:100%;cursor:pointer;" @click="openAlexa">
        <img width="96" class="mt-4 pa-2" :src="require('../../assets/alexa.png')"></img>
        <v-card-text>
          <p class="title secondary--text">{{ $t('introduce.alexa') }}</p>
          <p class="grey--text">{{ $t('introduce.alexa_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="py-4">
      <v-card class="mx-4 elevation-8 text-xs-center" style="height:100%;cursor:pointer;" @click="openAssistant">
        <img width="96" class="mt-4 pa-2" :src="require('../../assets/assistant.png')"></img>
        <v-card-text>
          <p class="title secondary--text">{{ $t('introduce.assistant') }}</p>
          <p class="grey--text">{{ $t('introduce.assistant_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="py-4">
      <v-card to="/macro" class="mx-4 elevation-8 text-xs-center" style="height:100%">
        <v-icon size="96" color="brown lighten-3" class="mt-4">call_split</v-icon>
        <v-card-text>
          <p class="title secondary--text">{{ $t('introduce.macro') }}</p>
          <p class="grey--text">{{ $t('introduce.macro_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="py-4">
      <v-card to="/kanban" class="mx-4 elevation-8 text-xs-center" style="height:100%">
        <v-icon size="96" color="pink lighten-3" class="mt-4">insert_chart_outlined</v-icon>
        <v-card-text>
          <p class="title secondary--text">{{ $t('introduce.visualization') }}</p>
          <p class="grey--text">{{ $t('introduce.visualization_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="py-4">
      <v-card to="/route" class="mx-4 elevation-8 text-xs-center" style="height:100%">
        <v-icon size="96" color="indigo lighten-3" class="mt-4">device_hub</v-icon>
        <v-card-text>
          <p class="title secondary--text">{{ $t('introduce.analysis') }}</p>
          <p class="grey--text">{{ $t('introduce.analysis_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="py-4">
      <v-card to="/gateway" class="mx-4 elevation-8 text-xs-center" style="height:100%">
        <v-icon size="96" color="purple lighten-3" class="mt-4">backup</v-icon>
        <v-card-text>
          <p class="title secondary--text">{{ $t('introduce.backup_your_gateway') }}</p>
          <p class="grey--text">{{ $t('introduce.backup_your_gateway_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="py-4">
      <v-card to="/gateway" class="mx-4 elevation-8 text-xs-center" style="height:100%">
        <v-icon size="96" color="teal lighten-3" class="mt-4">restore</v-icon>
        <v-card-text>
          <p class="title secondary--text">{{ $t('introduce.restore_your_gateway') }}</p>
          <p class="grey--text">{{ $t('introduce.restore_your_gateway_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="py-4">
      <v-card to="/camera" class="mx-4 elevation-8 text-xs-center" style="height:100%">
        <v-icon size="96" color="orange lighten-3" class="mt-4">camera</v-icon>
        <v-card-text>
          <p class="title secondary--text">{{ $t('introduce.watch_your_cameras') }}</p>
          <p class="grey--text">{{ $t('introduce.watch_your_cameras_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="py-4">
      <v-card to="/labeling" class="mx-4 elevation-8 text-xs-center" style="height:100%">
        <v-icon size="96" color="blue lighten-3" class="mt-4">face</v-icon>
        <v-card-text>
          <p class="title secondary--text">{{ $t('introduce.face_recongnition') }}</p>
          <p class="grey--text">{{ $t('introduce.face_recongnition_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md3 class="py-4">
      <v-card class="mx-4 elevation-8 text-xs-center" style="height:100%">
        <v-icon size="96" color="green lighten-3" class="mt-4">android</v-icon>
        <v-card-text>
          <p class="title secondary--text">{{ $t('introduce.android') }}</p>
          <v-img @click="gotoPlay" :src="require(`../../assets/AndroidBadges/${$i18n.locale}.svg`)" style="cursor:pointer"></v-img>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>

  <v-layout row justify-center class="pt-4 mt-5">
    <v-btn flat color="grey" to="/terms">{{ $t('introduce.terms') }}</v-btn>
    <v-btn flat color="grey" to="/privacy">{{ $t('introduce.privacy') }}</v-btn>
    <v-btn flat @click="gotoSupport" color="grey">{{ $t('introduce.support') }}</v-btn>
  </v-layout>

  <v-layout row justify-center class="py-4">
    <span class="caption grey--text">{{ $t('introduce.google_play_legal') }}</span>
  </v-layout>

</v-container>
</template>

<script>
export default {
  name: 'Introduce',
  methods: {
    gotoSupport() {
      window.open('https://luffanet.freshdesk.com/support/home', '_blank');
    },
    gotoPlay() {
      window.open('https://play.google.com/apps/testing/com.luffanet.console', '_blank');
      //window.open('https://play.google.com/store/apps/details?id=com.luffanet.console', '_blank');
    },
    openLine() {
      window.open('https://line.me/R/ti/p/%40ihs1032f', '_blank');
    },
    openAlexa() {
      window.open('https://www.amazon.com/dp/B07QPTV3M3', '_blank');
    },
    openAssistant() {
      window.open('https://assistant.google.com/services/a/uid/0000003e44398468?hl=en', '_blank');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Introduce.vue